<template>
  <div class="code_pop" v-if="codePop">
    <div class="code_content">
      <img :src="require(`@/assets/img/${device}/${region}/home/recharge_code.png`)" alt="">
      <img class="close_btn" src="@/assets/img/m/public/popup_close.png" alt="" @click="closeCodePop">
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex'
export default {
  components: {},
  data() {
    return {

    };
  },
  computed: {
    ...mapState(['codePop', 'device', 'region'])
  },
  watch: {},
  methods: {
    closeCodePop() {
      this.$store.commit('changeCodePop', false)
    }
  },
  created() {

  },
  mounted() {

  },
}
</script>
<style lang='less' scoped>
.code_pop {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.5);
  z-index: 9999;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;

  .code_content {
    width: 6.88rem;
    height: 7.61rem;
    position: relative;

    img {
      width: 100%;
      height: 100%;
    }

    .close_btn {
      width: 0.56rem;
      height: 0.4rem;
      position: absolute;
      top: .26rem;
      right: .3rem;
    }
  }
}
</style>